// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"gp-z","imageAndVideoCount":"hp-z","imageAndVideoContainer":"ip-z","viewAllReviews":"jp-z"};